export function processMarkdown(text: string) {
    // for css ".font-normal", **text** will wrap text in span with class "font-normal"
    const htmlText = text.replace(/\*\*([^*]+)\*\*/gim, `<span class="font-normal">$1</span>`);
    return htmlText.trim();
}
